import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";

const stats = [
  { number: 2432, label: "Happy Students" },
  { number: 59409, label: "Lessons Completed" },
  { number: 57, label: "Expert Teachers" },
  { number: 51, label: "Countries Reached" },
];

const StatsSection = () => {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={sectionStyle}>
      <Container>
        <Row className="text-center">
          {stats.map((stat, idx) => (
            <Col key={idx} lg={3} md={6} className="mb-4">
              <h2 style={numberStyle}>
                {startCount ? (
                  <CountUp end={stat.number} duration={2} separator="," />
                ) : (
                  0
                )}
              </h2>
              <p style={labelStyle}>{stat.label}</p>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

// Styles
const sectionStyle = {
  backgroundColor: "#0d3b66",
  color: "#fff",
  padding: "60px 0",
};

const numberStyle = {
  fontSize: "2.5rem",
  fontWeight: "700",
  marginBottom: "0.5rem",
};

const labelStyle = {
  fontSize: "1.1rem",
  fontWeight: "500",
};

export default StatsSection;
